import { render, staticRenderFns } from "./updating_metricspage.vue?vue&type=template&id=01fdf268"
import script from "./updating_metricspage.vue?vue&type=script&lang=js"
export * from "./updating_metricspage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports